/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Root export for the app module
 */

import {
  APP_MOUNTED,
  HIDE_APP_DOWNLOAD_BAR,
  INITIAL_LOCATION_CHANGED,
  INITIAL_LOCATION_HAS_UTM_PARAMS,
  INIT_LOCAL_STORAGE,
  SET_BOT,
  SET_MOBILE,
  SET_ONLINE,
  SET_SENDING_MESSAGE,
  SET_SENDING_TOUR,
  SET_WARN_OFFLINE,
  SHOW_APP_DOWNLOAD_BAR,
  UPDATE_NOW,
} from '@zcode-ui/web-zumper-global-state'
import { safeFilterActions } from '@zcode/utils'
import { appReducer } from './reducers/index'
import type { ActionTypes } from './types'

// This satisfies makes sure that everything in the whitelist is also used in the reducer
const actionTypes = [
  APP_MOUNTED,
  HIDE_APP_DOWNLOAD_BAR,
  INITIAL_LOCATION_CHANGED,
  INITIAL_LOCATION_HAS_UTM_PARAMS,
  INIT_LOCAL_STORAGE,
  SET_BOT,
  SET_MOBILE,
  SET_ONLINE,
  SET_SENDING_MESSAGE,
  SET_SENDING_TOUR,
  SET_WARN_OFFLINE,
  SHOW_APP_DOWNLOAD_BAR,
  UPDATE_NOW,
] as const satisfies ReadonlyArray<ActionTypes['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
declare const shouldBeEmpty: Exclude<ActionTypes['type'], (typeof actionTypes)[number]>
false && (shouldBeEmpty satisfies never)

export const app = safeFilterActions(appReducer, actionTypes)
